import React, { useEffect, useState } from "react";
import { getIndustries } from "../api/industryService";
import { sleep } from "../utils/sleep";

const Industries = () => {

  const [industries, setIndustries] = useState([]);
        const [loading, setLoading] = useState(true);
        const [error, setError] = useState(null);
      
          useEffect(() => {
          const fetchIndustries = async () => {
            try {
              // simulate network delay (3 sec)
              //await sleep(3000);
      
              const data = await getIndustries(); // asynchronous call
              setIndustries(data);
            } catch (err) {
              setError("Failed to load industries.");
            } finally {
              setLoading(false);
            }
          };
      
          fetchIndustries();
          }, []);
        
        // Loading Overlay
        if (loading) {
          return (
            <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
              <div className="spinner-border text-primary" role="status"></div>
              <span className="ms-3 fw-semibold">Loading industries...</span>
            </div>
          );
        }
        
         // Error Message
        if (error) {
          return (
            <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
              <p className="text-danger fs-7">{error}</p>
              <button
                className="btn btn-outline-primary mt-3"
                onClick={() => window.location.reload()}
              >
                Retry
              </button>
            </div>
          );
  }
  
  return (
    <section className="industries-section py-5">
      <div className="container">
        <h2 className="fw-bold text-center mb-4">
          Industries We <span className="text-primary-color">Serve</span>
        </h2>
<p className="text-muted text-center ps-3 mb-4">
  We deliver customized digital solutions for a wide range of industries, from innovative startups to established enterprises.
</p>
        <div className="row">
          {Object.entries(industries).map(([category, industryList], idx) => (
            <div className="col-md-6 col-lg-4 mb-4" key={idx}>
              <div className="industry-card bg-white shadow-sm rounded p-4 h-100">
                <h5 className="fw-semibold mb-3 text-secondary-color">{category}</h5>
                <div className="d-flex flex-wrap gap-2">
                  {industryList.map((industry, index) => (
                    <span
                      key={index}
                      className="industry-tag text-dark border px-3 py-1 rounded-pill"
                    >
                      {industry}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
